module.exports = __webpack_public_path__ + "static/media/Market.f578905e.svg";